import styles from './CardPayment.module.scss';

export const useOptions = () => {
  return {
    classes: {
      base: styles.cardPayment,
    }
  }
}
